import { LAYER_STACK } from "../constants/MapOptions";

/**
 * Returns correct beforeId for inserting a layer
 * based on global LAYER_STACK.
 */
export const getBeforeId = (map, layerOrder = []) => {
  if (!map) return undefined;
  if (map._removed) return undefined;
  if (!map.isStyleLoaded || !map.isStyleLoaded()) return undefined;

  try {
    const style = map.getStyle();
    if (!style?.layers) return undefined;

    for (const id of layerOrder) {
      if (map.getLayer(id)) return id;
    }
  } catch (err) {
    return undefined;
  }

  return undefined;
};